export const PROLOGUE = {
  title: "Prologue",
  paragraphs: [
    "Humans: we are all so different, so unique in our own ways. Each person lives a different life in a world of their own. But when you widen the lens and view from another part of the universe, it's just us as a whole — humanity, a life found only on Earth and soon on other planets. Humanity has come so far by breaking itself into numerous parts, with each part contributing to its advancement, much like the human body.",
    "Through billions of years of collective consciousness, of the living and the dead, humanity has grown, akin to the roots of a tree, with each generation deepening its existence. One way to help this process has been governance. A small part of humanity takes charge and directs the rest. The idea is excellent — a small group with the responsibility to aid the rest, ultimately expanding our collective existence.",
    "The concept of governance has continuously evolved, but there's something intrinsic about it. With great power comes great responsibility, yet for great responsibility, great power must also be given. The process of bestowing this power and finding the right individuals to exercise it has always been questionable. Many forms of transferring power have come and gone, from inheriting power and fighting wars for it to the current democratic systems where law reigns supreme and competent leaders are chosen by the people. But is the power held by these leaders justifiable? In this ever-changing world, is it still acceptable to adhere to ideologies of governance developed centuries ago?",
    "Implementing change in our current world is challenging, but what about Mars? A new planet free from all earthly norms. As we humans eye new settlements on Mars, seeking to form colonies, trying to expand human consciousness in this expanding universe, is it finally the time to also change the way humanity governs itself?",
    "Could it finally be time for a change?",
  ],
};

export const PRAISE = [
  {
    stars: 4,
    quote:
      "A thought-provoking science fiction novel that explores an alternate political system suited for life on Mars. The author's mature perspective challenges conventional governance and sparks deep reflection on humanity's future beyond Earth.",
    author: "Ayan Bhattacharya",
    source: "Goodreads · 4★",
  },
  {
    stars: 4,
    quote:
      "A thought-provoking debut from an author with great potential. The short but crisp story uses sci-fi as a tool to imagine an alternative political system — the commentary on our democratic systems and the reimagining of them is what really lies at the centre of this book.",
    author: "Achint",
    source: "Goodreads · 4★",
  },
  {
    stars: 5,
    quote:
      "There is something unique about the ideas presented in the book. It makes you rethink the future of politics and society — a great read for anyone eager to explore where humanity might govern itself next.",
    author: "Goodreads Reader",
    source: "Goodreads · 5★",
  },
  {
    stars: 4,
    quote:
      "It reminded me of the joy I experienced years ago reading Satyajit Ray's Professor Shanku — though less whimsical, it reignited my love for the genre. After years of mainstream sci-fi, Election on Mars feels refreshing.",
    author: "Ayan Bhattacharya",
    source: "Goodreads · 4★",
  },
];
